import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const ComparisonTable = ({ children, packageCount = 0, className = '' }) => (
  <table
    className={classnames(
      `sm-comparison-table`,
      { [`sm-comparison-table--${packageCount}`]: !!packageCount },
      className
    )}
    data-testid="ComparisonTable"
    tabIndex="-1"
  >
    {children}
  </table>
);

ComparisonTable.propTypes = {
  children: PropTypes.node.isRequired,
  packageCount: PropTypes.number,
  className: PropTypes.string,
};

ComparisonTable.defaultProps = {
  packageCount: 0,
  className: '',
};

export default ComparisonTable;
